export const config = {
  aplicacao: 'maxline',
  version: '1.0.0',
  build: '',
};
